import { handleActions } from 'redux-actions';
import { DATOS_PORTALCOBRANZAS, EDITAR_ACTIVO, MOSTRAR_ACTIVO, ELIMINAR_ACTIVO,
        CARGAR_IMAGEN_FACTURA, CARGAR_IMAGEN_LOCAL, ELIMINAR_IMAGEN_LOCAL, ELIMINAR_IMAGEN_FACTURA,
        CARGAR_IMAGEN_ACTIVO, ELIMINAR_IMAGEN_ACTIVO, LOGOUT } from '../actions';



const stateDefault = {
    buscarPoliza: {},
    declarante: {},
    siniestro: {},
    activos: [],
    cuentaAbono: {},
    buscarSiniestro: {},
    reportediario: {},
    afiliacion: {},
    transaccion: {},
    suscripcion: {},
    imagenesLocal: [],
    imagenesFactura: [],
    montoTotal: 0,
    mostrarActivo:{
        flag: false,
        index: -1,
    }
}

export default handleActions(
    {
        [DATOS_PORTALCOBRANZAS]: (state, action) => {

            let {keyObjeto, valueObjeto} = action.payload;
            let montoTotal = 0;
    
            if( "activos" === keyObjeto) {
                if(valueObjeto){
                    valueObjeto.map((item, i) => {
                        
                        if ( 0 < item.costo && item.indSeleccion ){
                            montoTotal = montoTotal + parseFloat(((item.costo.toString()).replace(",", ""))*item.cantidad);
                        }
                        return item;
                    });
                }
                
                if( "2" === JSON.parse(localStorage.getItem("FLUJO"))){
                    localStorage.setItem("montoTotal", montoTotal)
                }

            }else {
                montoTotal = state.montoTotal;
            }

            if(Object.values(valueObjeto).length > 0 ){
                
                localStorage.setItem("datosPortalCobranzas", JSON.stringify(Object.assign({}, state, {[keyObjeto]: valueObjeto, montoTotal})))
            }
                
                
            return  Object.assign({}, state, {[keyObjeto]: valueObjeto, montoTotal});
        },
        [EDITAR_ACTIVO]: (state, action) => {
            
            let {objeto, index} = action.payload;
            let montoTotal = 0;
            
            let stateActivos = Array.from(state.activos);
            stateActivos[index] = objeto;

            stateActivos.map((item)=>{
                if ( 0 !== item.costo ){
                    montoTotal = montoTotal + parseFloat(((item.costo.toString()).replace(",", ""))*item.cantidad);
                }
                return item;
            })
        
            return  Object.assign({}, state, {activos: stateActivos, montoTotal});
        },
        [MOSTRAR_ACTIVO]: (state, action) => {
            let { flag, index } = action.payload;

            if(!flag){ index = -1 };
            
            return  Object.assign({}, state, {mostrarActivo: {flag, index} });
        },
        [ELIMINAR_ACTIVO]: (state, action) => {
            let { index } = action.payload;
            let montoTotal = 0;

            let stateActivos = Array.from(state.activos);
            stateActivos.splice(index, 1);

            stateActivos.map((item)=>{
                if ( 0 !== item.costo ){
                    montoTotal = montoTotal + parseFloat(((item.costo.toString()).replace(",", ""))*item.cantidad);
                }
                return item;
            })
            
            return  Object.assign({}, state, {activos: stateActivos, montoTotal});
        },
        [CARGAR_IMAGEN_LOCAL]: (state, action) => {       
            let storeImg = Array.from(state.imagenesLocal);
            
            if(action.payload.imagenesLocal.length > 1){
                Object.values(action.payload.imagenesLocal).map(item => {
                    storeImg.push(item);
                    return item;
                })
            }else if(action.payload.imagenesLocal.length === 1){
                storeImg.push(action.payload.imagenesLocal[0]);
            }
            
            
            
            return Object.assign({}, state,{ imagenesLocal: storeImg });
        },

        [CARGAR_IMAGEN_FACTURA]: (state, action) => {

            
            return Object.assign({}, state,{ imagenesFactura: [...state.imagenesFactura, action.payload.imagenesFactura] });
        },
        [ELIMINAR_IMAGEN_LOCAL]: (state, action) => {
            let idActivo = action.payload.index;
            let newArrayImage = Array.from(state.imagenesLocal);
            
            newArrayImage.map((item, i) => {
                if(idActivo === item.idearchivoent){
                    newArrayImage.splice(i, 1);
                }
                return item;
            })
            
            return Object.assign({}, state ,{ imagenesLocal: newArrayImage });
        },

        [ELIMINAR_IMAGEN_FACTURA]: (state, action) => {
            let newArrayImage = Array.from(state.imagenesFactura);
            newArrayImage.splice(action.payload.index, 1);

            return Object.assign({}, state ,{ imagenesFactura: newArrayImage });
        },
        [CARGAR_IMAGEN_ACTIVO]: (state, action) => {
            let { file, index } = action.payload;
            let newArrayAction = Array.from(state.activos);
            newArrayAction[index].imagen = file;

            return Object.assign({}, state, { activos: newArrayAction });
        },
        [ELIMINAR_IMAGEN_ACTIVO]: (state, action) => {
            let { index } = action.payload;
            let newArrayAction = Array.from(state.activos);
            newArrayAction.splice(index, 1);

            return Object.assign({}, state, { activos: newArrayAction });
        },
        [LOGOUT] : (state, action) => { 
            return Object.assign({}, stateDefault);
        },

    }, stateDefault
);
